import { useState } from 'react';
import { versionTabs, versions } from '@/mocks/content';

export default function VersionSection() {
  const [active, setActive] = useState(versionTabs[0].id);
  const list = versions.filter((v) => v.tag === active);

  return (
    <section id="versions" className="w-full scroll-mt-20 bg-amber-50 py-14 md:py-20 border-y border-stone-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-orange-600">版本对比</span>
          <h2 className="font-heading mt-2 text-2xl md:text-4xl font-bold text-stone-900">
            先分清你是要哪一版，再谈在哪看
          </h2>
          <p className="mt-4 text-stone-600 leading-relaxed">
            网络上流传的片源大致可以按删改程度、画质与语言字幕三个维度来区分。下面按维度切换查看，
            每一类都写清楚了特点、片长差异和适合的人群，方便你对号入座。
          </p>
        </div>

        <div
          role="tablist"
          aria-label="版本分类"
          className="mt-7 inline-flex flex-wrap gap-1 p-1 rounded-full bg-white border border-stone-200"
        >
          {versionTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active === tab.id}
              onClick={() => setActive(tab.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                active === tab.id
                  ? 'bg-orange-500 text-white'
                  : 'text-stone-600 hover:text-orange-600'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((v) => (
            <article
              key={v.name}
              className="bg-white border border-stone-200 rounded-xl p-6 flex flex-col hover:border-orange-300 transition-colors"
            >
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-heading text-lg font-semibold text-stone-900">{v.name}</h3>
                <span className="shrink-0 px-2.5 py-1 rounded-full bg-rose-100 text-rose-700 text-xs">
                  {v.badge}
                </span>
              </div>
              <p className="mt-1 text-xs text-stone-400">{v.duration}</p>
              <p className="mt-4 text-sm text-stone-600 leading-relaxed grow">{v.desc}</p>
              <div className="mt-5 pt-4 border-t border-stone-200 flex items-start gap-2 text-sm">
                <i className="ri-user-smile-line text-orange-500 mt-0.5" aria-hidden="true"></i>
                <span className="text-stone-500">
                  <strong className="text-stone-700">适合：</strong>
                  {v.best}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}